import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./primeiroAcesso.css";
import Imagens from "../../../components/IMAGESCOMPONENT/ImageComponent";

function PrimeiroAcesso() {

  

  const [consultandoCnpj, setConsultandoCnpj] = useState(false);
  const [cnpjConsultado, setCnpjConsultado] = useState("");

  const [dadosLiberados, setDadosLiberados] = useState(false);

  const [mensagemCnpj, setMensagemCnpj] = useState("");

  const [loading, setLoading] = useState(false);
  const [cep, setCep] = useState("");
  const [enderecoHabilitado, setEnderecoHabilitado] = useState(false);
  const [erroCep, setErroCep] = useState("");
  const [mensagem, setMensagem] = useState(null);
  const navigate = useNavigate();

  const [endereco, setEndereco] = useState({
    rua: "",
    bairro: "",
    cidade: "",
    estado: "",
  });

  const [formData, setFormData] = useState({
    cnpj: "",
    inscestadual: "",
    numero: "",
    email: "",
  });

  async function buscarCep(valor) {
    const cepLimpo = valor.replace(/\D/g, "");
    setCep(valor);

    if (cepLimpo.length !== 8) {
      setEnderecoHabilitado(false);
      setErroCep("");
      setEndereco({ rua: "", bairro: "", cidade: "", estado: "" });
      return;
    }

    try {
      setErroCep("");
      const response = await fetch(
        `https://viacep.com.br/ws/${cepLimpo}/json/`
      );
      const data = await response.json();

      if (data.erro) {
        setErroCep("CEP não encontrado");
        setEnderecoHabilitado(false);
        return;
      }

      setEndereco({
        rua: data.logradouro || "",
        bairro: data.bairro || "",
        cidade: data.localidade || "",
        estado: data.uf || "",
      });

      // habilita endereço mesmo se vier vazio (CEP geral)
      setEnderecoHabilitado(true);
    } catch {
      setErroCep("Erro ao consultar CEP");
      setEnderecoHabilitado(false);
    }
  }

  function formatarCNPJ(valor) {
    const cnpj = valor.replace(/\D/g, "").slice(0, 14);

    return cnpj
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2");
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setMensagem(null);

    const body = {
      cnpj: formData.cnpj,
      inscestadual: formData.inscestadual,
      email: formData.email,
      endereco: endereco.rua,
      numero: formData.numero,
      bairro: endereco.bairro,
      cidade: endereco.cidade,
      uf: endereco.estado,
      cep: cep,
    };

    try {
      const res = await fetch(
        "https://app.eliandroalimentos.com.br/api/primeiro_acesso/salvar",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        }
      );

      const data = await res.json();
      console.log("salvar", data)
      if (!res.ok) {
        if (data.error === "Cliente não cadastrado no Nsys.") {
          setMensagem({
            texto: "CNPJ sem cadastro, favor cadastrar.",
            tipo: "erro",
            action: () => navigate("/cadastro"),
            textoLink: "CADASTRAR-SE",
          });
        } else if (
          data.error ===
          "O email informado não corresponde ao cadastro do cliente."
        ) {
          setMensagem({
            texto:
              "Email não corresponde ao cadastro, entre em contato com seu vendedor.",
            tipo: "erro",
          });
        } else if (data.errors && data.errors[0]?.msg === "Email inválido") {
          setMensagem({
            texto: "Email inválido, favor informar um email válido.",
            tipo: "erro",
          });
        } else if (
          data.error === "CNPJ já cadastrado no primeiro acesso." ||
          data.error === "Cliente já cadastrado com este email."
        ) {
          setMensagem({
            texto:
              "CNPJ já possui primeiro acesso. Caso tenha esquecido a senha, solicite uma nova.",
            tipo: "erro",
            action: () => navigate("/novasenha"),
            textoLink: "Solicitar Nova Senha",
          });
        } else {
          setMensagem({
            texto: data.error || "Erro desconhecido",
            tipo: "erro",
          });
        }
      } else {
        setMensagem({
          texto: `Acesso cadastrado com sucesso! Sua senha foi enviada para o email ${data.data.emailEnviadoPara}`,
          tipo: "sucesso",
        });
      }
    } catch {
      setMensagem({
        texto: "Sistema indisponível. Favor tente novamente mais tarde.",
        tipo: "erro",
      });
    } finally {
      setLoading(false);
    }
  }


  async function consultarCNPJ(cnpj) {
    if (cnpj.length !== 14) return;

    if (cnpj === cnpjConsultado) return;

    try {
      setConsultandoCnpj(true);

      const response = await fetch(
        `https://brasilapi.com.br/api/cnpj/v1/${cnpj}`
      );

      const data = await response.json();

      console.log("BrasilAPI:", data);

      // CEP formatado
      const cepFormatado = data.cep
        ? data.cep.replace(/^(\d{5})(\d{3})$/, "$1-$2")
        : "";

      setCep(cepFormatado);

      setEndereco({
        rua: `${data.descricao_tipo_de_logradouro || ""} ${data.logradouro || ""}`.trim(),
        bairro: data.bairro || "",
        cidade: data.municipio || "",
        estado: data.uf || "",
      });

      // Número separado
      setFormData((prev) => ({
        ...prev,
        numero: data.numero || "",
      }));

      // Habilita edição dos campos
      setEnderecoHabilitado(true);
      setDadosLiberados(true);
      setErroCep("");

      setCnpjConsultado(cnpj);
    } catch (err) {
      console.error("Erro ao consultar CNPJ", err);
      setDadosLiberados(true);
    } finally {
      setConsultandoCnpj(false);
    }
  }

  function verificarCNPJ() {
    if (!dadosLiberados) {
      setMensagemCnpj("Primeiro preencha o CNPJ.");

      setTimeout(() => {
        setMensagemCnpj("");
      }, 3000);

      return false;
    }

    return true;
  }

  return (
    <div className="primeiro-wrapper">
      <div className="primeiro-card">
        <div className="primeiro-brand">
          <img
            src={Imagens.Logo}
            alt="Eliandro Alimentos"
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          />
        </div>

        <div className="primeiro-text">
          <h2>Primeiro acesso</h2>
          <p>Preencha os dados da empresa para receber sua senha por email.</p>

          {mensagemCnpj && (
            <div className="mensagem-cnpj">
              {mensagemCnpj}
            </div>
          )}

        </div>


        <form className="primeiro-form" onSubmit={handleSubmit}>

          {/* CNPJ + IE */}
          <div className="form-row">
            <div className="input-group cnpj-group">
              <label>CNPJ</label>

              <input

                type="text"
                placeholder="00.000.000/0000-00"
                required
                value={formData.cnpj}
                onChange={(e) => {
                  const cnpjFormatado = formatarCNPJ(e.target.value);

                  setFormData((prev) => ({
                    ...prev,
                    cnpj: cnpjFormatado,
                  }));

                  const somenteNumeros = cnpjFormatado.replace(/\D/g, "");

                  if (somenteNumeros.length === 14) {
                    consultarCNPJ(somenteNumeros);
                  }
                }}
              />
            </div>


            {consultandoCnpj && (
              <div className="loading-overlay">
                <div className="loading-box">
                  <div className="loading-spinner"></div>
                  <span>Consultando CNPJ...</span>
                </div>
              </div>
            )}

            <div className="input-group ie-group">
              <label>Inscrição Estadual (IE)</label>
              <div
                onClick={() => !dadosLiberados && verificarCNPJ()}
              >
                <input

                  type="text"
                  placeholder="Digite a IE"
                  required
                  value={formData.inscestadual}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      inscestadual: e.target.value,
                    })
                  }
                /></div>
            </div>
          </div>

          {/* CEP + Número */}
          <div className="form-row">

            <div className="input-group cep-group">
              <label>CEP</label>
              <div
                onClick={() => !dadosLiberados && verificarCNPJ()}
              >
                <input
                  type="text"
                  placeholder="00000-000"
                  value={cep}
                  onChange={(e) => buscarCep(e.target.value)}
                  required
                /></div>

              {erroCep && (
                <span className="error-text">
                  {erroCep}
                </span>
              )}
            </div>

            <div className="input-group tooltip-wrapper numero-group">
              <label>Número</label>

              {!enderecoHabilitado && (
                <span className="tooltip-text">
                  Preencha o CEP primeiro
                </span>
              )}
              <div
                onClick={() => !dadosLiberados && verificarCNPJ()}
              >
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={formData.numero}
                  disabled={!enderecoHabilitado}
                  onChange={(e) => {
                    const somenteNumeros =
                      e.target.value.replace(/\D/g, "");

                    setFormData({
                      ...formData,
                      numero: somenteNumeros,
                    });
                  }}
                  placeholder="Número"
                  required
                /></div>
            </div>

          </div>

          {/* Rua */}
          <div className="input-group tooltip-wrapper">
            <label>Rua / Avenida</label>

            {!enderecoHabilitado && (
              <span className="tooltip-text">
                Preencha o CEP primeiro
              </span>
            )}
            <div
              onClick={() => !dadosLiberados && verificarCNPJ()}
            >
              <input
                type="text"
                value={endereco.rua}
                disabled={!enderecoHabilitado}
                onChange={(e) =>
                  setEndereco({
                    ...endereco,
                    rua: e.target.value,
                  })
                }
                placeholder="Rua / Avenida"
                required
              /></div>
          </div>

          {/* Bairro */}
          <div className="input-group tooltip-wrapper">
            <label>Bairro</label>

            {!enderecoHabilitado && (
              <span className="tooltip-text">
                Preencha o CEP primeiro
              </span>
            )}

            <div
              onClick={() => !dadosLiberados && verificarCNPJ()}
            >
              <input
                type="text"
                value={endereco.bairro}
                disabled={!enderecoHabilitado}
                onChange={(e) =>
                  setEndereco({
                    ...endereco,
                    bairro: e.target.value,
                  })
                }
                placeholder="Bairro"
                required
              /></div>
          </div>

          {/* Cidade + Estado */}
          <div className="form-row">

            <div className="input-group tooltip-wrapper cidade-group">
              <label>Cidade</label>

              {!enderecoHabilitado && (
                <span className="tooltip-text">
                  Preencha o CEP primeiro
                </span>
              )}

              <div
                onClick={() => !dadosLiberados && verificarCNPJ()}
              >
                <input
                  type="text"
                  value={endereco.cidade}
                  disabled={!enderecoHabilitado}
                  onChange={(e) =>
                    setEndereco({
                      ...endereco,
                      cidade: e.target.value,
                    })
                  }
                  required
                /></div>
            </div>

            <div className="input-group tooltip-wrapper uf-group">
              <label>Estado</label>

              {!enderecoHabilitado && (
                <span className="tooltip-text">
                  Preencha o CEP primeiro
                </span>
              )}

              <select
                value={endereco.estado}
                disabled={!enderecoHabilitado}
                onChange={(e) =>
                  setEndereco({
                    ...endereco,
                    estado: e.target.value,
                  })
                }
                required
              >
                <option value="">UF</option>
                <option value="RS">RS</option>
                <option value="SC">SC</option>
                <option value="PR">PR</option>
              </select>
            </div>

          </div>

          {/* Email */}
          <div className="input-group">
            <label>Email</label>

            <input
              type="email"
              placeholder="seu@email.com"
              required
              value={formData.email}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  email: e.target.value,
                })
              }
            />
          </div>

          {mensagem && (
            <div className={`mensagem ${mensagem.tipo}`}>
              {mensagem.texto}{" "}

              {mensagem.action && (
                <button
                  type="button"
                  className="mensagem-link"
                  onClick={mensagem.action}
                >
                  {mensagem.textoLink}
                </button>
              )}
            </div>
          )}

          <button
            className="primeiro-button"
            disabled={loading}
          >
            {loading ? "Solicitando..." : "Solicitar Senha"}
          </button>

        </form>

        <div className="primeiro-footer">
          <a href="/login">Voltar para login</a>
        </div>
      </div>
    </div>
  );
}

export default PrimeiroAcesso;
